// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"e3c8164a","320":"0bdeeb70","653":"f9edc6ba","921":"d428ddc4"}[chunkId] + ".chunk.css";
};